module.exports = __webpack_public_path__ + "img/img49.fa0eadb2.webp";